module.exports = __webpack_public_path__ + "img/hr-sand-decal-08.57020598.png";